export default defineNuxtPlugin(nuxtApp => {
  // TODO: pull this from the user's browser / use the server to figure this out.
  nuxtApp.vueApp.provide('language', 'en');
});
